<template>
    <b-button-group size="sm" class="btn-block">
        <b-button
            :pressed="issFilter === 'all'"
            variant="outline-secondary"
            @click="updateIssFilter('all')"
        >
            Toutes
        </b-button>
        <b-button
            :pressed="issFilter === 'advance'"
            variant="outline-primary"
            @click="updateIssFilter('advance')"
        >
            Acomptes
        </b-button>
        <b-button
            :pressed="issFilter === 'balance'"
            variant="outline-primary"
            @click="updateIssFilter('balance')"
        >
            Soldes
        </b-button>
    </b-button-group>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater'

export default {
    name: 'IssFilter',

    mixins: [DataUpdater],

    methods: {
        updateIssFilter(value) {
            this.$store.commit('browsing/SET_ISS_FILTER', value)
            this.updateData()
        },
    },

    computed: {
        ...mapState({
            issFilter: (state) => state.browsing.issFilter,
        }),
    },
}
</script>

<style scoped></style>
